module.exports = __webpack_public_path__ + "img/sailboat.b0e656b4.svg";